import React from "react";
import { Helmet } from "react-helmet";
import GridBackgroundDemo from "../components/gridBackground/GridBackgroundDemo";
import JoinUs from "../components/joinUs/JoinUs";
import FooterComponent from "../components/footer/FooterComponent";

const Home = () => {
  return (
    <div style={{ backgroundColor: "#121212" }}>
      <Helmet>
        <title>Little Learner | Fun, Interactive Learning for Kids</title>
        <meta
          name="description"
          content="Little Learner is a playful and engaging platform designed to help kids explore, learn, and grow through interactive lessons, creative activities, and personalized learning experiences that make education fun."
        />
        <meta
          name="keywords"
          content="Little Learner, kids learning, early education, interactive learning, fun learning for kids, preschool activities, child development, online learning for kids"
        />
        <meta
          property="og:title"
          content="Little Learner | Fun, Interactive Learning for Kids"
        />
        <meta
          property="og:description"
          content="Inspire curiosity and creativity with Little Learner — where education meets fun through interactive lessons and engaging activities for children."
        />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://littlelearner.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div>
        <GridBackgroundDemo />
        <JoinUs />
      </div>

      <div style={{ marginTop: 100 }}>
        <FooterComponent />
      </div>
    </div>
  );
};

export default Home;
